import { Info } from 'react-feather';
import BottomPopOver from '../BottomPopOver/BottomPopOver';

interface Props {
  title: string;
  text: string;
  text2?: string;
}

const Tooltip = ({ title, text, text2 }: Props) => {
  return (
    <>
      <span id={`popBottom_${1}`}>
        <Info size={14} />
      </span>
      <BottomPopOver
        title={title}
        text={text}
        text2={text2}
        id={1}
        target={'popBottom'}
      />
    </>
  );
};

export default Tooltip;
